import Styles from './index.module.scss';

import type { ComponentProps } from 'react';

export const IconButton = (props: ComponentProps<'button'>) => {
	return <button {...props} type="button" className={Styles.iconButton} />;
};
